module.exports = __webpack_public_path__ + "img/bot.51bb16d2.gif";